// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D68DI","colBig":"styles_colBig__27uxp","colSmall":"styles_colSmall__ZzBKb"};